module.exports = __webpack_public_path__ + "img/strategy-bg1.4e3c364e.jpg";